module.exports = __webpack_public_path__ + "static/media/auto-resilient-0-downtime.42993572.svg";